import { createSaga } from './saga-helpers';

import * as Api from '../api/annotations-api';

const watchGetAnnotations = createSaga({
    type: 'ANNOTATIONS_FETCH',
    fn: Api.fetchAnnotations,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        annotations: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateAnnotation = createSaga({
    type: 'ANNOTATION_CREATE',
    fn: Api.createAnnotation,
    args: action => [action.payload.annotation],
    successPayload: ({ id: annotationId, task_id }, action) => ({
        annotationId,
        task_id,
        fragment: action.payload.annotation
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.annotation
    })
});

const watchGetAnnotation = createSaga({
    type: 'ANNOTATION_FETCH',
    fn: Api.fetchAnnotation,
    args: action => [action.payload.annotationId],
    successPayload: annotation => ({ annotation })
});

const watchUpdateAnnotation = createSaga({
    type: 'ANNOTATION_UPDATE',
    fn: Api.updateAnnotation,
    args: action => [action.payload.annotationId, action.payload.annotationProps],
    successPayload: annotation => ({ annotation })
});

const watchRemoveAnnotation = createSaga({
    type: 'ANNOTATION_REMOVE',
    fn: Api.removeAnnotation,
    args: action => [action.payload.annotationId]
});

const sagas = [watchGetAnnotations, watchCreateAnnotation, watchGetAnnotation, watchUpdateAnnotation, watchRemoveAnnotation];

export default sagas;
